var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStarFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 18,
    viewBox: "0 0 20 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.41646 1.10883C9.54244 0.744612 10.0575 0.744611 10.1835 1.10883L12.1303 6.73716C12.1868 6.90066 12.3408 7.01033 12.5138 7.01033L18.7569 7.01033C19.1561 7.01033 19.3154 7.52627 18.9857 7.75134L13.9794 11.1681C13.8282 11.2713 13.7648 11.463 13.8247 11.636L15.747 17.1938C15.8748 17.5633 15.4576 17.8821 15.1347 17.6617L10.0288 14.1768C9.89078 14.0826 9.70919 14.0826 9.57122 14.1768L4.46524 17.6617C4.14234 17.8821 3.72515 17.5633 3.85295 17.1938L5.7753 11.636C5.83514 11.463 5.77175 11.2713 5.62055 11.1681L0.6143 7.75134C0.284543 7.52627 0.443829 7.01033 0.843069 7.01033L7.0862 7.01033C7.25919 7.01033 7.41317 6.90066 7.46972 6.73716L9.41646 1.10883Z",
    fill: "#F9C320"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarFilled);
export default __webpack_public_path__ + "static/media/star-filled.891fa1b36cef0212f57b318ad4c65616.svg";
export { ForwardRef as ReactComponent };